import React, { useEffect, useRef, useState } from 'react';
import { LabelLarge, LabelMedium } from '../../../../../component/Text';
import useAuth from '../../../../../hook/useAuth';
import { useMobile } from '../../../../../hook/usePlatform';

export interface LetterType {
  value:string
}
const Letter:React.FC<LetterType> = (props) => {
  const { user } = useAuth();
  const padding = 20;
  const isMobile = useMobile();
  return (
    <div
      style={{
        overflow: 'hidden',
        backgroundColor: 'white',
        position: 'relative',
        marginBlock: 34,
        width: '100%',
        paddingInline: padding,
        paddingTop: padding,
        paddingBottom: padding / 2,
      }}
    >

      <div style={{
        position: 'absolute',
        top: padding,
        bottom: padding,
        right: padding,
        left: padding,
      }}
      >
        {[...Array.from(Array(100).keys())].map((e) => (
          <div
            style={{
              height: isMobile ? 24 : 26,
              borderBottomWidth: '1px',
              borderBottomStyle: 'dashed',
              borderBottomColor: '#B8B8B8',
            }}
          />
        ))}
      </div>
      <LabelLarge style={{ fontFamily: 'inter' }}>
        [커플매니저의 추천글]
      </LabelLarge>
      <LabelMedium style={{ fontFamily: 'inter' }}>{props.value}</LabelMedium>
    </div>
  );
};

export default Letter;
